import React from 'react';

import './MarketValue.scss';

interface OwnProps {
    value: string;
}

type Props = OwnProps;

const MarketValue: React.FC<Props> = ({ value }) => (
    <div styleName="col title" className="__app-MarketValue-container">
        {value || '-'}
    </div>
);

export default MarketValue;
